import { ImageProps, Language, SenderIdOption, VoiceProps } from '@/app/module/campaigns/types'
import { CountryTimezone, FilesType, PersonalizationType, TimezoneWithCountryCodeType } from '@/app/types'

export type ResponseTextProps = {
  countriesTimezones: CountryTimezone[]
  countryCode: string
  defaultLanguage: string
  files: FilesType
  id: string
  index: number
  languages: Language[]
  orgId: number
  personalizationList: PersonalizationType
  senderIds: SenderIdOption[]
  timezones: TimezoneWithCountryCodeType
  timezone: string
  token: string
  whatsappSenderIds: SenderIdOption[]

  getImageProps: (qid: string) => ImageProps
  getVoiceProps: (qid: string) => VoiceProps
}

export enum AnswerType {
  OpenEnded = 'openEnded',
  Text = 'text',
  MultiSelect = 'multiSelect',
  WhatsAppButtons = 'whatsappButtons',
  WhatsAppList = 'whatsappList',
}
